import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  NgxQrcodeElementTypes,
  NgxQrcodeErrorCorrectionLevels,
} from "@techiediaries/ngx-qrcode";
import { Router } from "@angular/router";
import { AlertService } from "src/app/core/services/alert.service";
import { TranslateService } from "@ngx-translate/core";
import { User } from "src/app/core/models/users";
import { UsersService } from "src/app/core/services/users.service";
import jsPDF from "jspdf";

@Component({
  selector: "app-generate-qr-dialog",
  templateUrl: "./generate-qr-dialog.component.html",
  styleUrls: ["./generate-qr-dialog.component.scss"],
})
export class GenerateQrDialogComponent implements OnInit {
  options = {
    autoClose: true,
    keepAfterRouteChange: false,
  };
  elementType = NgxQrcodeElementTypes.URL;
  correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  bodyQR = `{ 
    "user" : "" , 
    "password" : "" 
  }`;

  constructor(
    @Inject(MAT_DIALOG_DATA) public user: User,
    public dialog: MatDialog,
    public router: Router,
    public alertService: AlertService,
    public translate: TranslateService,
    private usersService: UsersService
  ) {}

  ngOnInit(): void {}

  accept() {
    this.usersService
      .setCarrierPassword(this.user.userId)
      .subscribe((response: any) => {});
  }

  cancel() {
    this.dialog.closeAll();
  }

  getBase64Image(img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL;
  }

  print(): void {
    this.usersService
      .setCarrierPassword(this.user.userId)
      .subscribe((response: any) => {
        if (response.password != null) {
          this.bodyQR = `{"user": "${this.user.username}", "password": "${response.password}"}`;

          setTimeout(() => {
            const printContent = document.getElementById(
              "print-section-dialog"
            );
            const qr = printContent.firstChild.firstChild;
            const doc = new jsPDF();
            const ts = this.translate;
            this.dialog.closeAll();

            let imageData = this.getBase64Image(qr);

            doc.text(`${ts.instant("label.name")}: ${this.user.name}`, 15, 15);
            doc.text(
              `${ts.instant("label.domainUser")}: ${this.user.username}`,
              15,
              25
            );
            doc.text(
              `${ts.instant("label.email")}: ${this.user.email}`,
              15,
              35
            );

            doc.addImage(imageData, "JPG", 15, 45, 50, 50);

            doc.autoPrint();
            doc.save(`${this.user.username}.pdf`);
          }, 2500);
        }
      });
  }
}
